export default {
    BUSCAR_PARAMETROS: 'buscarParametrosAction',
    VALIDAR_DOCUMENTO_VIRTUALIZADO: 'validarDocumentoVirtualizado',
    BAIXAR_DOCUMENTOS_VIRTUALIZADOS: 'baixarDocumentosVirtualizados',
    BUSCAR_LICITACOES_PUBLICAS: 'buscarLicitacoesPublicas',
    BUSCAR_DADOS_GERAIS: 'buscarDadosGeraisLicitacao',
    BUSCAR_ANEXOS_EDITAL: 'buscarAnexosEdital',
    BUSCAR_ACOMPANHAMENTO: 'buscarAcompanhamento',
    BUSCAR_ACOMPANHAMENTO_DETALHE: 'buscarAcompanhamentoDetalhe',
    BUSCAR_ESCLARECIMENTO_IMPUGNACAO: 'buscarEsclarecimentoImpugnacaoAction',
    SOLICITAR_ESCLARECIMENTO_IMPUGNACAO: 'solicitarEsclarecimentoImpugnacaoAction',
    BAIXAR_RELATORIO_DA_ATA_DA_LICITACAO: 'baixarRelatorioDaAtaDaLicitacao',
    VALIDAR_CODIGO_EMAIL: 'validarCodigoEmailAction',
    BUSCAR_ESTADOS_EFORNECEDOR: 'buscarEstadosEfornecedor',
    BUSCAR_MUNICIPIOS_POR_ESTADO: 'buscarMunicipiosPorEstado',
    BUSCAR_PROCESSOS_PUBLICADOS: 'buscarProcessosPublicados',
    BUSCAR_PROCESSO_LICITACAO: 'buscarProcessoLicitacao',
    BUSCAR_LOTES_PAGINA_INTERNA: 'buscarLotesPaginaInterna',
    GERAR_XML_PROPOSTA_PRESENCIAL: 'gerarXMLPropostaPresencial',
    BUSCAR_LISTAGEM_SIMULAR_PROPOSTA: 'buscarListagemSimularProposta',
    FLOWBEE: {
        BAIXAR_ARQUIVO: 'baixarArquivo'
    },
}
